import getUserLoginStatus from "./getUserLoginStatus";

export const receiveUserIdentity = (
  state,
  { payload: { isAuthenticated, customerId } }
) => {
  const newState = {
    ...state,
    globals: {
      ...state.globals,
      loginStatus: getUserLoginStatus({ isAuthenticated }),
      customerId
    }
  };

  return newState;
};
